var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_545_77)" } }, [
        _c("path", {
          attrs: {
            d: "M9.22711 0.888047L9.22822 0.890342L11.2376 5.02471L11.4108 5.38102L11.8027 5.43884L16.2915 6.10107C16.2917 6.1011 16.292 6.10114 16.2922 6.10117C16.3853 6.11539 16.4632 6.18047 16.4938 6.2728C16.5225 6.35976 16.4993 6.45926 16.4318 6.52594L16.4315 6.52623L13.1753 9.7481L12.8982 10.0223L12.9633 10.4066L13.7348 14.9576C13.7349 14.9579 13.7349 14.9581 13.7349 14.9583C13.7499 15.0497 13.7125 15.1462 13.6304 15.2059C13.5579 15.2586 13.4565 15.2687 13.3664 15.2216C13.3661 15.2214 13.3657 15.2212 13.3653 15.2211L9.35914 13.0821L9.0059 12.8935L8.65266 13.0821L4.64646 15.2211C4.6461 15.2212 4.64575 15.2214 4.64539 15.2216C4.55933 15.2665 4.4553 15.2589 4.37738 15.203C4.30175 15.1488 4.26133 15.0526 4.27687 14.9582C4.2769 14.958 4.27693 14.9578 4.27695 14.9576L5.04544 10.4061L5.11029 10.022L4.83342 9.7481L1.57717 6.52623L1.57688 6.52594C1.51291 6.46272 1.48617 6.36222 1.51675 6.2672C1.54369 6.18345 1.61941 6.11595 1.7166 6.10115C1.71679 6.10113 1.71698 6.1011 1.71717 6.10107L6.20294 5.43882L6.59481 5.38097L6.76796 5.02471L8.77603 0.893004C8.77617 0.89272 8.77631 0.892437 8.77645 0.892154C8.82057 0.803047 8.9077 0.75 9.00278 0.75C9.10183 0.75 9.18769 0.80623 9.22711 0.888047Z",
            stroke: "#717986",
            "stroke-width": "1.5",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_545_77" } }, [
          _c("rect", { attrs: { width: "18", height: "16", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }